import { get } from "svelte/store";
import type { FormField, Validator } from "@shared/types/Form";

export const isProviAvailableInState = (
  stateSettings: { state: string; onboarding_delivery_dates: boolean }[],
): Validator => {
  return (value: string) => {
    return {
      name: "isProviAvailableInState",
      valid: !!stateSettings.find(stateSetting => stateSetting.state === value),
    };
  };
};

export const isValidAck = (
  liquorLicenseField: FormField,
  nonAlcoholicField: FormField,
): Validator => {
  return (value: boolean) => {
    let requiresAck = get(liquorLicenseField).value || get(nonAlcoholicField).value === "true";

    return {
      name: "isValidAck",
      valid: requiresAck ? !!value : true,
    };
  };
};
